import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export { default as Badge } from "./Badge.vue";

export const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-full border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
        secondary: "border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
        destructive:
          "border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline: "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        warning: "border-status-warning-border bg-status-warning-soft text-status-warning-strong",
        success: "border-transparent bg-status-success-soft text-status-success-strong",
        freemium: "border-transparent bg-violet-100 text-violet-700",
        neutral: "border-transparent bg-secondary font-medium text-muted-foreground",
        info: "border-status-info-border bg-status-info-soft text-status-info-strong",
        teal: "border-transparent bg-episto-teal/15 font-semibold text-episto-teal-700",
        danger: "border-status-error-border bg-status-error-soft text-status-error-strong",
        purple: "border-purple-200 bg-purple-100 text-purple-700",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);
export type BadgeVariants = VariantProps<typeof badgeVariants>;
